import React, { Component } from "react";
import {
  message,
    Spin,
    Row,
    Col,
    Divider,
    Select,
    Input,
    notification,
    Tabs,
    Modal,
    Popconfirm,
    Alert
} from "antd";
import {
  MensajeError,
    dineroDisabledMask,
    Form,
    FormItem,
    SelectItem,
    DatePickerItem,
    InputItem,
    ButtonItem,
    SwitchItem,
    ErrorItem,
    HeaderItem,
    BoxItem,
    NotificacionPolizas,
    NotificacionMovimientosInventario,
} from "../../../../Components/Items";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { PlusOutlined } from "@ant-design/icons";
import ElegirTipoDeCliente from "../../Clientes/ElegirTipoDeCliente/ElegirTipoDeCliente";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import MandarCorreo from "../../Ventas/MandarCorreo/MandarCorreo";
import qz from 'qz-tray';
import ticketPdf from "../../../../Pdf/ticketPdf";
import TabRelaciones from "../AgregarVenta/TabRelaciones/TabRelaciones";
import TabEnvio from "../AgregarVenta/TabEnvio/TabEnvio";
import TablaInsumosRefactura from "./TablaInsumosRefactura";
import ConfirmarEdicionInsumosRefactura from "./ConfirmarEdicionInsumosRefactura";
import printJS from "print-js";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

moment.locale("es");

const { Option } = Select;
const { TabPane } = Tabs;

class ModalRefacturarVenta extends Component {
    formRef = React.createRef();

    state = {
        loading: false,
        datosVenta: undefined,
        todasClientes: null,
        objetoClientes: null,
        objetoUsosDeCFDI: null,
        todasUsosDeCFDI: null,
        modalElegirTipoDeCliente: false,
        modalElegirTipoDeClienteId: null,
        modalElegirTipoDeClienteNombre: null,
        modalCorreo: false,
        modalCorreoId: null,
        complementoDetallista: false,
        detallista: null,
        todasRegimenFiscal: null,
        objetoRegimenFiscal: null,
        activarRegimenes: false,
        contado: 2,
        objetoUsuarios: null,
        todasSeriesVenta: [],
        ubicacionesEnvio: [],
        mercanciasEnvio: [],
        todasClientesEnvio: [],
        cartaPorteEditada: false,
        //Editar insumos al refacturar
        editarInsumos: false,
        edicionInsumosBloqueada: true,
        motivoBloqueoEdicionInsumos: null,
        proyectoIdEdicionInsumos: null,
        monedaEdicionInsumos: null,
        insumosEdicionOriginales: [],
        insumosEdicion: [],
        vistaPreviaEdicion: null,
        modalConfirmarEdicion: false,
        valoresPendientes: null,
    };

    componentDidUpdate(prevProps) {
        const becameVisible = !prevProps.visible && this.props.visible;
        const ventaCambio = prevProps.ventaId !== this.props.ventaId;
        if ((becameVisible || ventaCambio) && this.props.visible && this.props.ventaId) {
            // reset form si cambia la venta
            this.formRef.current?.resetFields();
            this.setState(
                {
                    datosVenta: undefined,
                    todasClientes: null,
                    objetoClientes: null,
                    objetoUsosDeCFDI: null,
                    todasUsosDeCFDI: null,
                    complementoDetallista: false,
                    detallista: null,
                    modalElegirTipoDeCliente: false,
                    modalElegirTipoDeClienteId: null,
                    modalElegirTipoDeClienteNombre: null,
                    modalCorreo: false,
                    modalCorreoId: null,
                    todasRegimenFiscal: null,
                    objetoRegimenFiscal: null,
                    activarRegimenes: false,
                    ubicacionesEnvio: [],
                    mercanciasEnvio: [],
                    todasClientesEnvio: [],
                    cartaPorteEditada: false,
                    editarInsumos: false,
                    edicionInsumosBloqueada: true,
                    motivoBloqueoEdicionInsumos: null,
                    proyectoIdEdicionInsumos: null,
                    monedaEdicionInsumos: null,
                    insumosEdicionOriginales: [],
                    insumosEdicion: [],
                    vistaPreviaEdicion: null,
                    modalConfirmarEdicion: false,
                    valoresPendientes: null,
                },
                () => this.consultarTodo()
            );
        }
    }

    consultarSeriesVenta() {
        axios
            .post(
                "serieventas/selectSeriesVentaActivas",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                const series = Array.isArray(res.data) ? res.data : [];
                this.setState({ todasSeriesVenta: series });
            });
    }

    async consultarTodo() {
        this.setState({ loading: true });
        if (
            this.props.complementoSeriesPersonalizadas &&
            this.props.permisoElegirSerieFolioPersonalizado
        ) {
            this.consultarSeriesVenta();
        }
        try {
            // Usos de CFDI
            const usosReq = axios.post(
                "usodecfdi/selectUsosDeCFDI",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            );

            const formasReq = axios.post(
                "formasDePago/selectFormasDePago",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            );

            // Clientes (sugeridos/iguales a la venta)
            const clientesReq = axios.post(
                "clientes/selectClientesIguales",
                { empresaId: this.props.empresaId, ventaId: this.props.ventaId },
                { headers: this.props.headersToken }
            );

            // Datos de la venta
            const ventaReq = axios.post(
                "ventas/datosVentaPRecibirP",
                { empresaId: this.props.empresaId, ventaId: this.props.ventaId },
                { headers: this.props.headersToken }
            );

            // Regímenes
            const regimenReq = axios.post(
                "ventas/selectDatosParaRegimen",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            );

            const usuariosReq = axios.post(
                "usuarios/selectUsuariosEmpresa",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            );

            //Renglones para el check "Editar insumos" y, si no se puede, el motivo. Con su propio catch
            //para que una falla aqui no deje sin datos el resto del modal
            const edicionInsumosReq = axios
                .post(
                    "ventas/datosEdicionInsumosRefactura",
                    { empresaId: this.props.empresaId, ventaId: this.props.ventaId },
                    { headers: this.props.headersToken }
                )
                .catch(() => null);

            const [usosRes, clientesRes, ventaRes, regimenRes, formasRes, usuariosRes, edicionInsumosRes] = await Promise.all([
                usosReq,
                clientesReq,
                ventaReq,
                regimenReq,
                formasReq,
                usuariosReq,
                edicionInsumosReq
            ]);

            if (edicionInsumosRes?.data?.success === 2) {
                const renglones = (edicionInsumosRes.data.insumos || []).map((valueInsumo) => ({ ...valueInsumo }));
                this.setState({
                    edicionInsumosBloqueada: !!edicionInsumosRes.data.bloqueado,
                    motivoBloqueoEdicionInsumos: edicionInsumosRes.data.motivo,
                    proyectoIdEdicionInsumos: edicionInsumosRes.data.proyectoId,
                    monedaEdicionInsumos: edicionInsumosRes.data.moneda,
                    insumosEdicionOriginales: renglones,
                    //consultarTodo tambien corre al elegir tipo de cliente: no perder lo ya editado
                    insumosEdicion: this.state.editarInsumos
                        ? this.state.insumosEdicion
                        : renglones.map((valueInsumo) => ({ ...valueInsumo })),
                });
            } else {
                this.setState({
                    edicionInsumosBloqueada: true,
                    motivoBloqueoEdicionInsumos: "No se pudieron consultar los insumos de la factura.",
                });
            }

            // Usos de CFDI
            if (usosRes?.data && usosRes.data.status !== 404) {
                const lista = usosRes.data;
                this.setState({
                    todasUsosDeCFDI: lista,
                    objetoUsosDeCFDI: lista.map((value) => (
                        <Option value={value._id} key={value._id}>
                            {value?.c_UsoCFDI + ' - ' + value.descripcion}
                        </Option>
                    )),
                });
            }

            // Usuarios
            if (usuariosRes?.data && usuariosRes.data.status !== 404) {
                const lista = usuariosRes.data;
                this.setState({
                    objetoUsuarios: lista.map((value) => (
                        <Option value={value._id} key={value._id}>
                            {value.nombre + ' ' + value.apellidoPaterno + ' ' + value.apellidoMaterno}
                        </Option>
                    )),
                });
            }

            // Formas de Pago
            if (formasRes?.data && formasRes.data.status !== 404) {
                const lista = formasRes.data;
                this.setState({
                    todasFormasDePago: lista,
                    objetoFormasDePago: lista.map((value) => (
                        <Option value={value._id} key={value._id}>
                            {value?.c_FormaPago + ' - ' + value.descripcion}
                        </Option>
                    )),
                });
            }

            // Clientes
            if (clientesRes?.data && clientesRes.data.status !== 404) {
                const lista = clientesRes.data;
                this.setState({
                    todasClientes: lista,
                    objetoClientes: lista.map((value) => (
                        <Option value={value._id} key={value._id}>
                            {value.stringBuscar}
                        </Option>
                    )),
                });
            }

            // Venta
            if (!ventaRes?.data || ventaRes.data.status === 404) {
                message.error("Error: no se encontró información de la venta");
            } else {
                const v = ventaRes.data.venta;
                this.setState({
                    datosVenta: v,
                    contado: v.contado,
                    complementoDetallista: v.cliente.complementoDetallista,
                    detallista: {
                        orderIdentification: v.cliente.orderIdentification,
                        referenceDateOrderIdentification: v.cliente.referenceDateOrderIdentification,
                        additionalInformation: v.cliente.additionalInformation,
                        deliveryNote: v.cliente.deliveryNote,
                        referenceDateDeliveryNote: v.cliente.referenceDateDeliveryNote,
                    },
                    ubicacionesEnvio: v.ubicacionesEnvio || [],
                    mercanciasEnvio: v.mercanciasEnvio || [],
                    //selectClientesIguales excluye al cliente de la venta y TabEnvio lo necesita
                    //para el autollenado de direcciones y mercancias guardadas
                    todasClientesEnvio: [
                        v.cliente,
                        ...((clientesRes?.data && clientesRes.data.status !== 404) ? clientesRes.data : []),
                    ],
                }, () => {
                    //Se hace en el callback porque el tab de Envio no existe hasta que
                    //datosVenta esta en el state, y sus campos tienen initialValue
                    this.formRef.current?.setFieldsValue({
                        usoDeCfdiId: v.usoDeCfdiId,
                        formaDePagoId: v.formaDePagoId,
                        vendedorId: v.vendedorId,
                        relacionesCFDI: [
                            {
                                tipoRelacion: "04",
                                uuid: v.dataFactura.uuid,
                            }
                        ],
                        //Carta porte
                        clienteId: v.clienteId,
                        proyectoTransporteId: v.proyectoTransporteId,
                        remolquesIds: v.remolquesIds,
                        remolquesEventuales: v.remolquesEventuales,
                        choferesIds: v.choferesIds,
                        tranporteInt: v.tranporteInt,
                        registroISTMO: v.registroISTMO,
                        ubicacionPoloOrigenId: v.ubicacionPoloOrigenId,
                        ubicacionPoloDestinoId: v.ubicacionPoloDestinoId,
                    });
                });
            }

            // Regímenes
            if (regimenRes?.data?.success === 2) {
                const { regimenesFiscales, activarRegimenes, regimenDefaultId } = regimenRes.data;
                this.setState({
                    objetoRegimenFiscal: regimenesFiscales.map((value) => (
                        <Option value={value._id} key={value._id}>
                            {value.c_RegimenFiscal + " - " + value.descripcion}
                        </Option>
                    )),
                    activarRegimenes,
                    todasRegimenFiscal: regimenesFiscales,
                });
                if (activarRegimenes) {
                    this.formRef.current?.setFieldsValue({ regimenFiscalId: regimenDefaultId });
                }
            } else {
                message.warning("No se encontraron datos de regímenes fiscales");
            }
        } catch (e) {
            message.error("Ocurrió un error al consultar datos");
        } finally {
            this.setState({ loading: false });
        }
    }

    onFinishFailed = (e) => {
        ErrorItem(e);
    };

    editarUbicacionesEnvio = (value) => {
        this.setState({ ubicacionesEnvio: value, cartaPorteEditada: true });
    };

    editarMercanciasEnvio = (value) => {
        this.setState({ mercanciasEnvio: value, cartaPorteEditada: true });
    };

    onValuesChange = (changed) => {
        const camposEnvio = [
            "proyectoTransporteId",
            "remolquesIds",
            "remolquesEventuales",
            "choferesIds",
            "tranporteInt",
            "registroISTMO",
            "ubicacionPoloOrigenId",
            "ubicacionPoloDestinoId",
        ];
        if (this.state.cartaPorteEditada) return;
        if (Object.keys(changed).some((valueKey) => camposEnvio.includes(valueKey))) {
            this.setState({ cartaPorteEditada: true });
        }
    };

    mostrarTabEnvio = () => (
        this.props.fletes &&
        this.state.ubicacionesEnvio?.length > 0 &&
        this.state.mercanciasEnvio?.length > 0
    );

    onChangeEditarInsumos = (checked) => {
        //Al apagarlo se regresa a los renglones de la factura, para no refacturar con cambios a medias
        this.setState({
            editarInsumos: checked,
            vistaPreviaEdicion: null,
            ...(checked ? {} : { insumosEdicion: this.state.insumosEdicionOriginales.map((valueInsumo) => ({ ...valueInsumo })) }),
        });
    };

    onChangeInsumosEdicion = (insumos) => {
        this.setState({ insumosEdicion: insumos, vistaPreviaEdicion: null });
    };

    //Lista blanca, igual que EditarRemisionVenta: el backend calcula importes y conserva el resto del renglon
    construirPayloadInsumosEdicion = () => this.state.insumosEdicion.map((valueInsumo) => ({
        _id: valueInsumo._id,
        insumoId: valueInsumo.insumoId,
        proyectoId: valueInsumo.proyectoId,
        cantidad: Number(valueInsumo.cantidad || 0),
        precioUnitario: Number(valueInsumo.precioUnitario || 0),
        descuento: Number(valueInsumo.descuento || 0),
        descuentoCantidad: Number(valueInsumo.descuentoCantidad || 0),
        leyenda: valueInsumo.leyenda,
        observaciones: valueInsumo.observaciones,
    }));

    onFinish = (values) => {
        if (values.editarInsumos) {
            this.previsualizarEdicionInsumos(values);
        } else {
            this.refacturar(values);
        }
    };

    //Antes de timbrar se le ensena al usuario que movimientos de inventario, pago y polizas se van a hacer
    previsualizarEdicionInsumos = (values) => {
        if (this.state.insumosEdicion.length === 0) {
            message.warning("La factura debe tener al menos un insumo.");
            return;
        }
        this.setState({ loading: true });
        axios
            .post(
                "ventas/previsualizarEdicionInsumosRefactura",
                {
                    empresaId: this.props.empresaId,
                    ventaId: this.props.ventaId,
                    insumos: this.construirPayloadInsumosEdicion(),
                    cambiarCliente: values.cambiarCliente,
                    clienteFacturaId: values.clienteFacturaId,
                    formaDePagoId: values.formaDePagoId,
                },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success !== 2) {
                    message.error("Ocurrió un error al revisar los cambios de los insumos.");
                    return;
                }
                if (res.data.bloqueado) {
                    MensajeError({
                        message: "No se pueden editar los insumos",
                        description: res.data.motivo,
                    });
                    return;
                }
                if (res.data.sinCambios) {
                    message.info("No cambiaste ningún insumo: se refacturará sin editarlos.");
                    this.refacturar({ ...values, editarInsumos: false });
                    return;
                }
                this.setState({
                    vistaPreviaEdicion: res.data,
                    modalConfirmarEdicion: true,
                    valoresPendientes: values,
                });
            })
            .catch(() => {
                this.setState({ loading: false });
                message.error("Ocurrió un error al revisar los cambios de los insumos.");
            });
    };

    confirmarEdicionInsumos = () => {
        const values = this.state.valoresPendientes;
        this.setState({ modalConfirmarEdicion: false });
        this.refacturar({
            ...values,
            editarInsumos: true,
            insumosEditados: this.construirPayloadInsumosEdicion(),
        });
    };

    regresarEdicionInsumos = () => {
        this.setState({ modalConfirmarEdicion: false });
    };

    refacturar = (values) => {
        this.setState({ loading: true });
        axios
            .post(
                "ventas/refacturarVenta",
                {
                    ...values,
                    empresaId: this.props.empresaId,
                    ventaId: this.props.ventaId,
                    ...(this.mostrarTabEnvio()
                        ? {
                            cartaPorteEditada: this.state.cartaPorteEditada,
                            ubicacionesEnvio: this.state.ubicacionesEnvio,
                            mercanciasEnvio: this.state.mercanciasEnvio,
                        }
                        : { cartaPorteEditada: false }),
                },
                { headers: this.props.headersToken }
            )
            .then(async (res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    if (res.data.messageSuccess) {
                        notification.warning({
                            description: "Revisar",
                            message: res.data.messageSuccess,
                            duration: 0,
                        });
                    }
                    message.success(res.data.messageSuccess || "Se ha generado una factura de la venta");
                    if (values.editarInsumos) {
                        NotificacionPolizas(res.data.polizasId);
                        NotificacionMovimientosInventario(res.data.movimientosIds);
                    }
                    this.setState({ modalCorreo: true, modalCorreoId: res.data.ventaId });

                    // Imprimir ticket si se requiere
                    this.printTicket(res.data)
                } else if (res.data.success === 1) {
                    MensajeError({
                      message: res.data.errorTimbrado?.titulo || res.data.message || "No se puede generar la factura",
                      description: res.data.errorTimbrado?.mensaje || res.data.description,
                      detalleTecnico: res.data.errorTimbrado?.detalleTecnico,
                    });
                } else {
                    message.error("Hubo un error y no se generó la factura");
                }
            })
            .catch(() => {
                this.setState({ loading: false });
                message.error("Error al generar la factura");
            });
    };

    printTicket = async (dataTicket) => {
        try {

            if (!this.props.impresoraSeleccionada) {
                throw new Error("No hay impresora seleccionada");
            }

            if (!qz.websocket.isActive()) {
                await qz.websocket.connect();
            }

            const config = await qz.configs.create(this.props.impresoraSeleccionada ? this.props.impresoraSeleccionada : "",
                {
                    encoding: 'Cp1252',
                    scaleContent: false,     // No escalar el contenido del PDF
                    rasterize: true,        // Evita convertir a imagen si no quieres que reduzca resolución
                    density: 300             // Ajusta según tu impresora (203 o 300 dpi típico)
                }
            );


            // const data = ticketEscPos(dataTicket);
            const pdf2 = ticketPdf({ ...dataTicket, factura: true });
            const base64_1 = await new Promise((resolve) => {
                pdfMake.createPdf(pdf2).getBase64((base64) => resolve(base64));
            });

            await qz.print(config, [
                {
                    type: 'pixel',
                    format: 'pdf',
                    flavor: 'base64',
                    data: base64_1
                },
            ]);

            await qz.websocket.disconnect();
            // await qz.print(config, data);

        } catch (err) {
            console.error('Error imprimiendo ticket:', err);
            const pdf2 = ticketPdf({ ...dataTicket, factura: true });
            pdfMake.createPdf(pdf2).getBlob((blob) => {
                const pdfURL = URL.createObjectURL(blob);

                const ua = navigator.userAgent || "";
                const isAndroid = /Android/i.test(ua);

                // Chrome en iOS aparece como "CriOS"
                const isChromeiOS = /CriOS/i.test(ua);

                // WebView Android común (opcional pero útil)
                const isWebViewAndroid =
                    isAndroid && /wv|Version\/\d+\.\d+.*Chrome\/\d+/i.test(ua);

                // ❌ Navegadores que NO pueden con printJS → visor directo
                if (isAndroid || isWebViewAndroid || isChromeiOS) {
                    const win = window.open(pdfURL, "_blank");
                    if (!win) window.location.href = pdfURL;
                    setTimeout(() => URL.revokeObjectURL(pdfURL), 60000);
                    return;
                }

                // ✅ Navegadores que SÍ pueden (o al menos vale la pena intentar)
                // Intentamos printJS y NO hacemos fallback si falla
                try {
                    printJS({
                        printable: pdfURL,
                        type: "pdf",
                        showModal: false,
                    });
                } catch (e) {
                    // Si falla de inmediato, NO hacemos nada más
                    message.error("No se pudo imprimir el ticket automáticamente. Cambie de navegador (por ejemplo, Chrome o Firefox).");
                    console.warn("printJS falló inmediatamente:", e);
                }

                // No revocar rápido o rompes printJS
                setTimeout(() => URL.revokeObjectURL(pdfURL), 60000);
            });
        }
    }

    cerrar = () => {
        this.props.cerrarModalRefacturar?.();
    };

    agregarCliente = () => {
        // Puedes abrir otra ruta o un modal según tu flujo
        this.props.history?.push?.("/panel/agregarCliente");
    };

    onChangeCliente = (valueId) => {
        const cliente = this.state.todasClientes?.find((c) => c._id === valueId);
        if (!cliente) return;

        if (!cliente.regimenFiscalId || !cliente.direcciones[0]?.coloniaId) {
            message.info("No se podrá facturar a este cliente. Faltan datos");
        }
        if (!cliente.tipoClienteId) {
            const nombre = cliente.persona
                ? cliente.razonSocial
                : `${cliente.nombre} ${cliente.apellidoPaterno} ${cliente.apellidoMaterno}`;
            this.abrirElegirTipoDeCliente(cliente._id, nombre);
        }
        this.setState({
            complementoDetallista: cliente.complementoDetallista,
            detallista: {
                orderIdentification: cliente.orderIdentification,
                referenceDateOrderIdentification: cliente.referenceDateOrderIdentification,
                additionalInformation: cliente.additionalInformation,
                deliveryNote: cliente.deliveryNote,
                referenceDateDeliveryNote: cliente.referenceDateDeliveryNote,
            },
        });
        this.formRef.current?.setFieldsValue({
            usoDeCfdiId: cliente.usoDeCFDIID,
            //TabEnvio lee clienteId para las direcciones y mercancias guardadas del cliente
            clienteId: cliente._id,
        });
    };

    abrirElegirTipoDeCliente = (id, nombre) => {
        this.setState({
            modalElegirTipoDeCliente: true,
            modalElegirTipoDeClienteId: id,
            modalElegirTipoDeClienteNombre: nombre,
        });
    };

    cerrarElegirTipoDeCliente = (elegido) => {
        if (!elegido) {
            this.formRef.current?.setFieldsValue({ clienteFacturaId: undefined });
        }
        // refrescar datos (por si se actualizó el cliente)
        this.consultarTodo();
        this.setState({
            modalElegirTipoDeCliente: false,
            modalElegirTipoDeClienteId: null,
            modalElegirTipoDeClienteNombre: null,
        });
    };

    cerrarMandarCorreo = () => {
        this.setState({
            modalCorreo: false,
            modalCorreoId: null,
        });
        this.formRef.current?.resetFields();
        this.cerrar();
    };

    onChangeCambiarCliente = (value) => {
        if (!value) {
            const c = this.state.datosVenta?.cliente;
            this.setState({
                complementoDetallista: c?.complementoDetallista,
                detallista: {
                    orderIdentification: c?.orderIdentification,
                    referenceDateOrderIdentification: c?.referenceDateOrderIdentification,
                    additionalInformation: c?.additionalInformation,
                    deliveryNote: c?.deliveryNote,
                    referenceDateDeliveryNote: c?.referenceDateDeliveryNote,
                },
            });
            //Al desactivar el switch se regresa al cliente original de la venta
            this.formRef.current?.setFieldsValue({
                clienteId: this.state.datosVenta?.clienteId,
            });
        } else {
            this.setState({ complementoDetallista: false });
        }
    };

    render() {
        const { visible } = this.props;
        //Con "Editar insumos" y su vista previa, el cuadro de totales ensena los de la factura nueva
        const datosVenta = (this.state.editarInsumos && this.state.vistaPreviaEdicion?.ventaDespues) || this.state.datosVenta;

        return (
            <Modal
                visible={visible}
                title={
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span>Refacturar Venta</span>
                    </div>
                }
                onCancel={this.props.cerrarModalRefacturar}
                footer={null}
                width={1000}
                maskClosable={false}
                destroyOnClose
                zIndex={1040}
                bodyStyle={{ paddingTop: 8, paddingBottom: 8, maxHeight: "70vh", overflow: "auto" }}
            >
                <Spin spinning={this.state.loading}>
                    <Form
                        ref={this.formRef}
                        name="refacturarVentaModal"
                        layout
                        bottom={
                            <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                                <ButtonItem onClick={this.cerrar} rojo>Cancelar</ButtonItem>
                                <Popconfirm
                                    title={"Se cancelara el timbre actual y se generara uno nuevo. ¿Desea continuar?"}
                                    onConfirm={() => this.formRef.current.formRef.current.submit()}
                                    okText="Ok"
                                    cancelText="Cancelar"
                                >
                                    <ButtonItem morado type="primary">
                                        Refacturar
                                    </ButtonItem>
                                </Popconfirm>
                            </div>
                        }
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                        onValuesChange={this.onValuesChange}
                    >
                        <Tabs defaultActiveKey={1} size="small">
                            <TabPane tab="General" tabKey={1} key={1} forceRender>
                                <Row gutter={[16, 8]}>
                                    <Col span={24}>
                                        {this.state.activarRegimenes && (
                                            <>
                                                <HeaderItem>REGIMEN FISCAL</HeaderItem>
                                                <BoxItem>
                                                    <FormItem
                                                        label="Regimen Fiscal"
                                                        name="regimenFiscalId"
                                                        margin
                                                        required
                                                    >
                                                        <SelectItem placeholder="Regimen Fiscal">
                                                            {this.state.objetoRegimenFiscal}
                                                        </SelectItem>
                                                    </FormItem>
                                                </BoxItem>
                                            </>
                                        )}
                                        {this.props.complementoSeriesPersonalizadas && this.props.permisoElegirSerieFolioPersonalizado && this.state.todasSeriesVenta.length > 0 && (
                                            <>
                                                <HeaderItem>SERIE</HeaderItem>
                                                <BoxItem>
                                                    <FormItem
                                                        label="Serie"
                                                        name="serieVentaId"
                                                        margin
                                                    >
                                                        <SelectItem placeholder="Selecciona una serie (opcional)" allowClear>
                                                            {this.state.todasSeriesVenta.map((serie) => (
                                                                <Option value={serie._id} key={serie._id}>
                                                                    {`${serie.nombre} (${serie.serieFacturas}/${serie.serieRemisiones}) - Sig. Factura: ${serie.folioFacturas ?? 1}`}
                                                                </Option>
                                                            ))}
                                                        </SelectItem>
                                                    </FormItem>
                                                </BoxItem>
                                            </>
                                        )}
                                        <HeaderItem>DATOS CLIENTE</HeaderItem>
                                        <BoxItem>
                                            <FormItem
                                                name="cambiarCliente"
                                                label="Cambiar Cliente"
                                                margin
                                                valuePropName="checked"
                                                initialValue={false}
                                            >
                                                <SwitchItem onChange={this.onChangeCambiarCliente} />
                                            </FormItem>

                                            <FormItem shouldUpdate noStyle>
                                                {({ getFieldValue }) => {
                                                    const cambiarCliente = getFieldValue("cambiarCliente");
                                                    if (cambiarCliente) {
                                                        return (
                                                            <FormItem margin label="Cliente">
                                                                <Input.Group compact>
                                                                    <FormItem name="clienteFacturaId" noStyle required>
                                                                        <SelectItem
                                                                            onChange={this.onChangeCliente}
                                                                            placeholder="Cliente"
                                                                            width="80%"
                                                                        >
                                                                            {this.state.objetoClientes}
                                                                        </SelectItem>
                                                                    </FormItem>
                                                                    <ButtonItem
                                                                        disabled
                                                                        icon={<PlusOutlined />}
                                                                        style={{ width: "20%" }}
                                                                        onClick={this.agregarCliente}
                                                                    />
                                                                </Input.Group>
                                                            </FormItem>
                                                        );
                                                    }
                                                    return null;
                                                }}
                                            </FormItem>

                                            <FormItem name="usoDeCfdiId" label="Uso de CFDI" margin required>
                                                <SelectItem placeholder="Uso de CFDI">
                                                    {this.state.objetoUsosDeCFDI}
                                                </SelectItem>
                                            </FormItem>

                                            <FormItem name="formaDePagoId" label="Forma de Pago" margin required>
                                                <SelectItem disabled={this.state.contado !== 1} placeholder="Forma de Pago">
                                                    {this.state.objetoFormasDePago}
                                                </SelectItem>
                                            </FormItem>

                                            <FormItem
                                                label="Vendedor"
                                                name="vendedorId"
                                                margin
                                                required
                                            >
                                                <SelectItem placeholder="Vendedor">
                                                    {this.state.objetoUsuarios}
                                                </SelectItem>
                                            </FormItem>
                                        </BoxItem>
                                        <HeaderItem>INSUMOS</HeaderItem>
                                        <BoxItem>
                                            <FormItem
                                                name="editarInsumos"
                                                label="Editar Insumos"
                                                margin
                                                valuePropName="checked"
                                                initialValue={false}
                                            >
                                                <SwitchItem
                                                    disabled={this.state.edicionInsumosBloqueada}
                                                    onChange={this.onChangeEditarInsumos}
                                                />
                                            </FormItem>
                                            {this.state.edicionInsumosBloqueada && this.state.motivoBloqueoEdicionInsumos ? (
                                                <Alert
                                                    type="info"
                                                    showIcon
                                                    message={this.state.motivoBloqueoEdicionInsumos}
                                                />
                                            ) : null}
                                            {this.state.editarInsumos ? (
                                                <Alert
                                                    type="warning"
                                                    showIcon
                                                    message="Edita los insumos en la pestaña Insumos. Antes de refacturar se te mostrará qué movimientos de inventario, pólizas y cambios al pago se van a hacer."
                                                />
                                            ) : null}
                                        </BoxItem>
                                    </Col>
                                </Row>

                                <Divider style={{ marginBottom: 10, marginTop: 5 }} />

                                <Row>
                                    <Col span={16} xs={24} sm={24} lg={16} xl={16} />
                                    <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                                        <h1 style={{ textAlign: "center", fontSize: 20 }}>Total Venta</h1>
                                        {datosVenta && (
                                            <table className="table">
                                                <tbody>
                                                    <tr>
                                                        <th className="th-totales" style={{ width: "50%" }}>
                                                            Subtotal
                                                        </th>
                                                        <td className="td-totales-right" style={{ width: "50%" }}>
                                                            {dineroDisabledMask(datosVenta.subtotal)}
                                                        </td>
                                                    </tr>
                                                </tbody>

                                                {datosVenta.arrayImpuestos?.map((valueArray) => (
                                                    <tbody key={valueArray.descripcionFactura}>
                                                        <tr>
                                                            <th className="th-totales">{valueArray.descripcionFactura}</th>
                                                            <td className="td-totales-right">
                                                                {dineroDisabledMask(valueArray.totalImpuestos)}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                ))}

                                                <tbody>
                                                    <tr>
                                                        <th className="th-totales">Total</th>
                                                        <td className="td-totales-right">
                                                            {dineroDisabledMask(datosVenta.total)}
                                                        </td>
                                                    </tr>
                                                </tbody>

                                                {datosVenta.arrayRetenciones?.map((valueArrayRet) => (
                                                    <tbody key={valueArrayRet.descripcionFactura}>
                                                        <tr>
                                                            <th className="th-totales">
                                                                {valueArrayRet.descripcionFactura}
                                                            </th>
                                                            <td className="td-totales-right">
                                                                {dineroDisabledMask(valueArrayRet.totalRetenciones)}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                ))}

                                                <tbody>
                                                    <tr>
                                                        <th className="th-totales">Total Pagar</th>
                                                        <td className="td-totales-right">
                                                            {dineroDisabledMask(datosVenta.totalPagar)}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        )}
                                    </Col>
                                </Row>
                            </TabPane>
                            {this.state.editarInsumos ? (
                                <TabPane tab='Insumos' tabKey='7' key='7' forceRender>
                                    {this.mostrarTabEnvio() ? (
                                        <Alert
                                            type="warning"
                                            showIcon
                                            style={{ marginBottom: 10 }}
                                            message="Esta factura lleva carta porte: revisa que las mercancías del tab Envío coincidan con los insumos nuevos."
                                        />
                                    ) : null}
                                    <TablaInsumosRefactura
                                        insumos={this.state.insumosEdicion}
                                        onChange={this.onChangeInsumosEdicion}
                                        proyectoId={this.state.proyectoIdEdicionInsumos}
                                        moneda={this.state.monedaEdicionInsumos}
                                        empresaId={this.props.empresaId}
                                        headersToken={this.props.headersToken}
                                    />
                                </TabPane>
                            ) : null}
                            <TabPane tab='CFDIs Relacionados' tabKey='4' key='4' forceRender>
                                <TabRelaciones />
                            </TabPane>

                            {this.mostrarTabEnvio() ? (
                                <TabPane tab='Envio' tabKey='6' key='6' forceRender>
                                    <TabEnvio
                                        editarUbicacionesEnvio={this.editarUbicacionesEnvio}
                                        editarMercanciasEnvio={this.editarMercanciasEnvio}
                                        ubicacionesEnvio={this.state.ubicacionesEnvio}
                                        mercanciasEnvio={this.state.mercanciasEnvio}
                                        formRefGeneral={this.formRef}
                                        todasClientes={this.state.todasClientesEnvio}
                                        onCambioCartaPorte={() => this.setState({ cartaPorteEditada: true })}
                                    />
                                </TabPane>
                            ) : null}

                            <TabPane tab='Cancelacion' tabKey='5' key='5' forceRender>
                                <FormItem
                                    label="Motivo"
                                    name="motivo"
                                    required
                                    pattern
                                    margin
                                    max={200}
                                    initialValue="01"
                                >
                                    <SelectItem placeholder="Motivo">
                                        <Option value="01">
                                            01 - Comprobante emitido con errores con relación.
                                        </Option>
                                        <Option value="02">
                                            02 - Comprobante emitido con errores sin relación.
                                        </Option>
                                        <Option value="03">03 - No se llevó a cabo la operación.</Option>
                                        <Option value="04">
                                            04 - Operación nominativa relacionada en una factura global.
                                        </Option>
                                    </SelectItem>
                                </FormItem>
                                <FormItem
                                    label="Folio Sustitución"
                                    name="folioSustitucion"
                                    pattern
                                    margin
                                    max={200}
                                >
                                    <InputItem placeholder="Si se queda vacío se pondra el de la nueva factura generada" />
                                </FormItem>
                            </TabPane>

                            {this.state.complementoDetallista && this.props.complementoDetallista ? (
                                <TabPane tab="Detallista" tabKey={2} key={2} forceRender>
                                    {this.state?.detallista?.orderIdentification && (
                                        <FormItem
                                            name="orderIdentification"
                                            label="OrderIdentification"
                                            margin
                                            labelCol={{ span: 6 }}
                                            wrapperCol={{ span: 18 }}
                                            required
                                        >
                                            <InputItem placeholder="OrderIdentification" />
                                        </FormItem>
                                    )}

                                    {this.state?.detallista?.referenceDateOrderIdentification && (
                                        <FormItem
                                            name="referenceDateOrderIdentification"
                                            label="ReferenceDateOrderIdentification"
                                            margin
                                            labelCol={{ span: 6 }}
                                            wrapperCol={{ span: 18 }}
                                            required
                                        >
                                            <DatePickerItem placeholder="ReferenceDateOrderIdentification" />
                                        </FormItem>
                                    )}

                                    {this.state?.detallista?.additionalInformation && (
                                        <>
                                            <FormItem
                                                name="typeAdditionalInformation"
                                                label="TypeAdditionalInformation"
                                                margin
                                                labelCol={{ span: 6 }}
                                                wrapperCol={{ span: 18 }}
                                                required
                                            >
                                                <SelectItem placeholder="Type - AdditionalInformation">
                                                    <Option value="AAE">AAE - Cuenta predial</Option>
                                                    <Option value="CK">CK - Número de cheque</Option>
                                                    <Option value="ACE">ACE - Numero de documento(Remisión)</Option>
                                                    <Option value="ATZ">ATZ - Número de aprobación.</Option>
                                                    <Option value="AWR">AWR - Numero de documento que  se reemplaza</Option>
                                                    <Option value="ON">ON - Número de pedido (comprador)</Option>
                                                    <Option value="DQ">DQ - Folio de recibo de mercancías</Option>
                                                    <Option value="IV">IV - Número de Factura</Option>
                                                </SelectItem>
                                            </FormItem>

                                            <FormItem
                                                name="referenceIdentificationAdditionalInformation"
                                                label="ReferenceIdentification"
                                                margin
                                                labelCol={{ span: 6 }}
                                                wrapperCol={{ span: 18 }}
                                                required
                                            >
                                                <InputItem placeholder="ReferenceIdentification - AdditionalInformation" />
                                            </FormItem>
                                        </>
                                    )}

                                    {this.state?.detallista?.deliveryNote && (
                                        <FormItem
                                            name="deliveryNote"
                                            label="DeliveryNote"
                                            margin
                                            labelCol={{ span: 6 }}
                                            wrapperCol={{ span: 18 }}
                                            required
                                        >
                                            <InputItem placeholder="DeliveryNote" />
                                        </FormItem>
                                    )}

                                    {this.state?.detallista?.referenceDateDeliveryNote && (
                                        <FormItem
                                            name="referenceDateDeliveryNote"
                                            label="ReferenceDateDeliveryNote"
                                            margin
                                            labelCol={{ span: 6 }}
                                            wrapperCol={{ span: 18 }}
                                            required
                                        >
                                            <DatePickerItem placeholder="ReferenceDateDeliveryNote" />
                                        </FormItem>
                                    )}
                                </TabPane>
                            ) : null}
                        </Tabs>
                    </Form>
                </Spin>

                <ElegirTipoDeCliente
                    visible={this.state.modalElegirTipoDeCliente}
                    id={this.state.modalElegirTipoDeClienteId}
                    nombre={this.state.modalElegirTipoDeClienteNombre}
                    cerrarElegirTipoDeCliente={this.cerrarElegirTipoDeCliente}
                />

                <MandarCorreo
                    zIndex={1200}
                    visible={this.state.modalCorreo}
                    id={this.state.modalCorreoId}
                    cerrarMandarCorreo={this.cerrarMandarCorreo}
                />

                {/* Mismo zIndex que este modal (memoria: un hijo mas alto tapa los dropdowns) */}
                <ConfirmarEdicionInsumosRefactura
                    zIndex={1040}
                    visible={this.state.modalConfirmarEdicion}
                    vistaPrevia={this.state.vistaPreviaEdicion}
                    onConfirmar={this.confirmarEdicionInsumos}
                    onRegresar={this.regresarEdicionInsumos}
                />
            </Modal>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    complementoDetallista: state.empresa.complementoDetallista,
    complementoSeriesPersonalizadas: state.empresa.complementoSeriesPersonalizadas,
    fletes: state.empresa.fletes,
    permisoElegirSerieFolioPersonalizado:
        state.user.tipo === 0 ||
        state.user.permisos.find(
            (valueTodos) =>
                valueTodos.permisoId.toString() === "6a9b6273e58adfd453dfa6f7"
        )?.activado,
});

export default connect(mapStateToProps)(ModalRefacturarVenta);
